import React from "react";
import { Grid2 } from "@mui/material";
import { Branch } from "../../../interfaces/entities/branch";
import { User } from "../../../interfaces/entities/user";
import { EmployeeCardView } from "../employeeCardView/employeeCardView";
import { getRoleLabel } from "../../../utils/userRoleLabel";

interface EmployeeListViewProps {
  users: User[];
  branch?: Branch;
}

export const EmployeeListView: React.FC<EmployeeListViewProps> = ({ users, branch }) => {

  return (
    <>
    
      <Grid2 container spacing={2} sx={{ padding: 2 }}>
        {users.map((user) => {
          const roleLabel = getRoleLabel(user.role);
          return (
            <Grid2 key={user.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <EmployeeCardView
                userData={user}
                branch={branch}
                roleLabel={roleLabel}
              />
            </Grid2>
          );
        })}
      </Grid2>
    </>
  );
};

